import dynamic from 'next/dynamic';
import React from 'react';

import config from 'configs/app';

interface Props {
  children: React.ReactNode;
}

const Web3ModalProvider = dynamic(
  () => import('ui/shared/Web3ModalProvider'),
  { ssr: false },
);

export default function Web3Provider({ children }: Props) {
  if (!config.features.blockchainInteraction.isEnabled) {
    return <>{ children }</>;
  }

  return (
    <Web3ModalProvider>
      { children }
    </Web3ModalProvider>
  );
}
